module.exports = __webpack_public_path__ + "img/Federal_Certificate.9d17a817.jpg";